export default __webpack_public_path__ + "static/media/DeleteIcon.4b06176a.svg";